import { Appearances } from 'models/SectionBlock';
import { Section } from 'components/Section';
import styles from './textAdLink.scss';
import { TextLinkBlock } from 'models/TextLinkBlock';

export const TextAdLink = ({ title, url }: TextLinkBlock) => {
  return (
    <Section isClear appearance={Appearances.Tertiary} className={styles.text}>
      <a href={url} className={styles.link}>
        {title}
      </a>
    </Section>
  );
};
